import { appConfig } from "@shared/utils/appConfig";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const BYPASS_ENABLED = appConfig.APP_ENV !== "production";

type Props = {
  queryParam: string;
};

export const useBypassedValue = (props: Props) => {
  const { queryParam } = props;
  const [search] = useSearchParams();

  const getBypassedDateValue = useCallback(
    (date: Date | undefined) => {
      if (!BYPASS_ENABLED) return date;

      const dateBypassed = search.get(queryParam);

      if (!dateBypassed) return date;

      try {
        return new Date(
          dateBypassed.length === 10 ? `${dateBypassed}T23:59:59` : dateBypassed
        );
      } catch {
        return date;
      }
    },
    [queryParam, search]
  );

  return {
    getBypassedDateValue,
  };
};
